import { Box, Grid, Typography } from "@deere/fuel-react";
import { POPUP_QUESTIONS_TITLES, QUESTION_TYPES } from "../../utils/constants";
import { getTranslation, getSelectionsDependson } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { DEFAULT_GRID_COLLUMNS, PART_FIRST_NAME_COLUMN, PART_SUPPLIER_NUMBER_COLUMN, PART_RACF_COLUMN, PARTS_TABLE_ACCESSOR_KEYS, PART_LAST_NAME_COLUMN, EWDC } from "../../utils/surveyLiterals";

const PartsTableReview = ({ questions, surveyData, campaign, multiplePartSections, sectionCode, code, defaultColumns }) => {
  const { t } = useTranslation();
  const fixedPartsData = code === EWDC ?
  [
    { field: PARTS_TABLE_ACCESSOR_KEYS.SUPPLIER_NUM, headerName: PART_SUPPLIER_NUMBER_COLUMN },
    { field: PARTS_TABLE_ACCESSOR_KEYS.DEERE_PART_NUM, headerName: PART_FIRST_NAME_COLUMN },
    { field: PARTS_TABLE_ACCESSOR_KEYS.DEERE_PART_DESC, headerName: PART_LAST_NAME_COLUMN },
    { field: PARTS_TABLE_ACCESSOR_KEYS.HS_CODE, headerName: PART_RACF_COLUMN },
  ]
  : campaign.isNonDeere?
  [
    { field: PARTS_TABLE_ACCESSOR_KEYS.SUPPLIER_NUM, headerName: t("parts_tbl_column_header_1") },
    { field: PARTS_TABLE_ACCESSOR_KEYS.PART_NUM, headerName: t("parts_tbl_column_header_2") },
    { field: PARTS_TABLE_ACCESSOR_KEYS.PART_DESC, headerName: t("parts_tbl_column_header_3") },
  ] :
  [
    { field: PARTS_TABLE_ACCESSOR_KEYS.SUPPLIER_NUM, headerName: t("parts_tbl_column_header_1") },
    { field: PARTS_TABLE_ACCESSOR_KEYS.DEERE_PART_NUM, headerName: t("parts_tbl_column_header_2") },
    { field: PARTS_TABLE_ACCESSOR_KEYS.DEERE_PART_DESC, headerName: t("parts_tbl_column_header_3") },
  ];
  if (code !== EWDC) {
    defaultColumns.forEach((dc) => {
      if (dc.defaultColumnMapping && dc.defaultColumnMapping !== "" && campaign.isNonDeere === dc.isNonDeere) {
        if (dc.defaultColumnMapping === "additional_column_1")
          fixedPartsData.push({ field: "additionalColumn1", headerName: getTranslation(dc, 'columnNames'), description: getTranslation(dc, 'columnNames'), minWidth: 100, flex: 1 });
        else 
          fixedPartsData.push({ field: "additionalColumn2", headerName: getTranslation(dc, 'columnNames'), description: getTranslation(dc, 'columnNames'), minWidth: 100, flex: 1 });
      }
    });
  }
  const gridsize = DEFAULT_GRID_COLLUMNS / fixedPartsData.length;
  const parts = multiplePartSections ? surveyData.parts.filter(part=> part.surveySectionCode === sectionCode) : surveyData.parts;
  const partAnswers = surveyData.partAnswers;
  const quesToRender = questions.filter((que) => !POPUP_QUESTIONS_TITLES.includes(que.type) );


  const getAnswer = (queId, partId, queType) => {
    const partAns = partAnswers.find((ptAns) => ptAns.partId == partId && ptAns.questionId == queId);
    let answer = partAns ? partAns.answer : "";
    if (queType === QUESTION_TYPES.SELECT) {
      let question = questions.find((que) => que.id === queId);
      if (question && question.selections && question.selections.length > 0) {
        let value = question.selections.find((sel) => sel.value == answer);
        if (value) answer = value.text ? value.text : "";
      }
    }else if (queType === QUESTION_TYPES.MULTI_SEL) {
      let question = questions.find((que) => que.id === queId);
      if (question && question.selections && question.selections.length > 0) {
        const answerArray = Array.isArray(answer) ? answer : answer.split(",");
        const values = answerArray.map((ans) => question.selections.find((sel) => sel.value == ans)).filter((val) => val && val.text);
        answer = values.map((val) => val.text ? val.text : "").join(", ");
      }
    }
    return answer;
  };

  const getCollumnsByQuestion = (questionsGroup) => {
    const questionsInGroup = questions.filter((q) => q.questionsGroup === questionsGroup);
    return questionsInGroup ? DEFAULT_GRID_COLLUMNS / questionsInGroup.length : DEFAULT_GRID_COLLUMNS;
  };

  const shouldRender = (que, partId) => {
    let render = false;
    if (!que.idQuestionDepends || que.idQuestionDepends === 0) {
      render = true;
    } else {
      let parent = questions.find((q) => q.id === que.idQuestionDepends);
      if (parent) {
        const parentAns = partAnswers.find((ptAns) => ptAns.partId.toString() === partId.toString() && ptAns.questionId.toString() === parent.id.toString());
        if (parent.type === QUESTION_TYPES.CHECK) {
          const selectionDependsOn_Check = que.idSelectionDependson.toString() === "0" ? "true" : "";
          const parentAns_Check = !parentAns || parentAns === "" ? "" : parentAns.answer;
          if (parentAns_Check === selectionDependsOn_Check) render = true;
        }
        else if (parent.type === QUESTION_TYPES.MULTI_SEL && parentAns && getSelectionsDependson(que).some((dep) => (Array.isArray(parentAns.answer) ? parentAns.answer : String(parentAns.answer).split(",")).map((value) => String(value).trim()).includes(dep))) {
          render = true;
        }
        else if (POPUP_QUESTIONS_TITLES.includes(parent?.type) && parentAns && parentAns.answer !== "") {
          render = true;
        } else if (que.idSelectionDependson === 0 && parentAns && parentAns.answer !== "") {
          render = true;
        } else if (parentAns && getSelectionsDependson(que).includes(String(parentAns.answer))) {
          render = true;
        }
      }
    }
    return render;
  };

  return (
    <>
      {parts.map((part, index) => {
        return (
          <Box key={part.id} sx={{ border: "1px solid grey", marginBottom: "10px", backgroundColor: `${index % 2 === 0 ? "#e5e5e5" : "white"}`, padding: "10px" }}>
            <Grid container>
              {fixedPartsData.map((data) => {
                return (
                  <Grid item xs={gridsize} p={2} key={`${part.id}_${data.field}`}>
                    <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
                      {data.headerName}
                    </Typography>
                    <Typography size="sm" component="p" gutterBottom>
                      {part[data.field] ? part[data.field] : ""}
                    </Typography>
                  </Grid>
                );
              })}
              {quesToRender.map((que) => {
                const collumnsByQuestion = que.questionsGroup ? getCollumnsByQuestion(que.questionsGroup) : DEFAULT_GRID_COLLUMNS;
                return shouldRender(que, part.id) ? (
                  <Grid item xs={collumnsByQuestion} p={2} key={`${part.id}_${que.id}`}>
                    <Typography size="sm" component="p" gutterBottom fontWeight="semibold">
                      {getTranslation(que, "text")}
                    </Typography>
                    <Typography size="sm" component="p" gutterBottom>
                      {getAnswer(que.id, part.id, que.type)}
                    </Typography>
                  </Grid>
                ) : null;
              })}
            </Grid>
          </Box>
        );
      })}
    </>
  );
};

export default PartsTableReview;
